/// <reference path="../../../teva/selectbox/selectbox.ts" />
/// <reference path="../../../teva/sortable/sortable.ts" />
/// <reference path="../../../teva/slideorfade/slideorfade.ts" />
/// <reference path="../../../teva/infinitescroll/infinitescroll.ts" />
/// <reference path="../../../teva/htmlhelpers/htmlhelpers.ts" />
/// <reference path="../../common/modals/modals.ts" />
/// <reference path="../../common/navigation/navigation.ts" />
/// <reference path="../../common/inputs/canvas/canvas.ts" />
/// <reference path="../../common/common/common.ts" />
/// <reference path="../entitypicker/entitypicker.ts" />

namespace OfficeGuy.CRM {
    export class Main {
        static $EntitiesList_MenuElement: any;
        static FilterNameIndex = 0;
        static $EntityMenu_Container: any;

        static Init() {
            $(document)
                .on("keyup.shiftslash", null, "Shift+/", function (Event) {
                    if ((<any>Event.target).contentEditable == "true")
                        return true;

                    OfficeGuy.Modals.ShowURLModal("/help/shortcuts/");
                    return false;
                })
                .on("keyup.alth", null, "Alt+H", function () {
                    Navigation.Redirect(OfficeGuy.Common.RootURL);
                    return false;
                });
            /*.on("keyup.alts", null, "Alt+S", function () {
                Teva.SelectBox.GetInstance($("#MainSearch")).ShowResults();
                return false;
            })*/
        }
        static PageLoad(): void {
            Main.$EntityMenu_Container = null;
            Main.FilterNameIndex = 0;
            Main.$EntitiesList_MenuElement = null;

            var $CRMForm = $("form.crmform:not(.crmform_entities)");
            if ($CRMForm.length > 0) {
                $("input, select, textarea, .og-richtexteditor", $CRMForm)
                    .on("keyup.ctrlenter", null, "ctrl+return", function () {
                        $("input[type=submit]", $CRMForm).trigger("click");
                        return false;
                    })
                    .on("keyup.altt", null, "alt+t", function () {
                        if ($('input[name=SaveDuplicate]').length == 0)
                            return true;

                        $('input[name=SaveDuplicate]').val('D');
                        $("input[type=submit]", $CRMForm).trigger("click");
                        return false;
                    });
            }
        }

        static InitSearchPagePagination() {
            Teva.InfiniteScroll.Enable({
                ResultsContainerSelector: ".og-mainsearch-results",
                ItemSelector: "a",
                PaginationSelector: ".og-mainsearch-pagination",
                NextSelector: ".og-mainsearch-pagination a",
                UseInnerScroll: true,
                CustomGetContent: function ($NextPageLink, SuccessCallback) {
                    Common.AjaxRequest({
                        URL: "/crm/search/",
                        ContentType: "application/x-www-form-urlencoded; charset=UTF-8",
                        ProcessData: false,
                        Data: "page=" + $NextPageLink.attr("data-page") + "&term=" + $NextPageLink.attr("data-term"),
                        SuccessMethod: SuccessCallback,
                        ShowLoading: false
                    })
                }
            });
        }

        static MainSearchRequestThrottleNextRequest;
        static MainSearchRequestThrottleTimeout;
        static MainSearchRequestThrottlePendingRequests = new Array();
        static MainSearchVisibleTerm;

        static MainSearchChanged(Term, Page) {
            Main.MainSearchRequestThrottleNextRequest = {
                Term: Term,
                Page: Page
            };
            if (Main.MainSearchRequestThrottleTimeout != null)
                return;

            Main.MainSearchRequestThrottleTimeout = setTimeout(function () {
                Main.MainSearchRequestThrottleTimeout = null;
                var NextRequest = Main.MainSearchRequestThrottleNextRequest;
                Main.MainSearchRequestThrottleNextRequest = null;
                Main.MainSearchRequestThrottlePendingRequests.push(NextRequest);
                Main.RefreshMainSearchResults(NextRequest);
            }, 250);
        }
        static RefreshMainSearchResults(Request) {
            if (Request.Term.length == 0) {
                Main.MainSearchVisibleTerm = "";
                $(".og-mainsearch-results-container").empty();
                return;
            }
            if (Main.MainSearchVisibleTerm == Request.Term)
                return;

            $(".og-mainsearch-results-container").html("מחפש...");

            Common.AjaxRequest({
                URL: "/crm/search/",
                ContentType: "application/x-www-form-urlencoded; charset=UTF-8",
                ProcessData: false,
                Data: "Partial=true&term=" + encodeURI(Request.Term),
                SuccessMethod: function (Response) {
                    var Index = $.inArray(Request, Main.MainSearchRequestThrottlePendingRequests);
                    var IsLast = Index == Main.MainSearchRequestThrottlePendingRequests.length - 1;
                    Main.MainSearchRequestThrottlePendingRequests.splice(Index, 1);
                    if (!IsLast)
                        return;

                    Main.MainSearchVisibleTerm = Request.Term;
                    $(".og-mainsearch-results-container").html($(Response).html());
                    Main.InitSearchPagePagination();
                },
                ShowLoading: false
            });
        }

        static InitSearchPageKeyboardNavigation() {
            $(window)
                .off("keydown.SearchPageKeyboardNavigation")
                .on("keydown.SearchPageKeyboardNavigation", function (Event) {
                    if ($(".og-mainsearch-results-container").length == 0) {
                        $(window).off("keydown.SearchPageKeyboardNavigation");
                        return true;
                    }

                    var $FocusedElement = $(':focus');
                    if (Event.key == "ArrowDown") {
                        if ($FocusedElement.hasClass("sumit-lightbox-item"))
                            $FocusedElement.next().trigger('focus');
                        else
                            $(".sumit-lightbox-item:first").trigger('focus');
                        return false;
                    }
                    else if (Event.key == "ArrowUp") {
                        if ($FocusedElement.hasClass("sumit-lightbox-item") && $FocusedElement.prev().length != 0)
                            $FocusedElement.prev().trigger('focus');
                        else
                            $("#Term").trigger('focus');
                        return false;
                    }
                    else
                        return true;

                });
        }

        static UpdateCustomFields(Container?): void {
            $(".og-richtexteditor", Container).each(function () {
                var $this = $(this);
                (<any>$this).cleanHtml();
                $this.nextAll("input:hidden:first").val(this.innerHTML);
            });
            $(".hyperlinkdetails", Container).each(function () {
                var Text = <string>$(".hyperlink_text", this).val();
                var URL = <string>$(".hyperlink_url", this).val();
                if (URL.length == 0)
                    $(this).next().val(null);
                else
                    $(this).next().val(JSON.stringify({ Text: Text, URL: URL }));
            });
            $(".schemaviewdetails", Container).each(function () {
                var SchemaID = <string>$("input.schemapicker", this).val();
                var ViewID = <string>$("input.viewpicker", this).val();
                if (SchemaID.length == 0 || ViewID.length == 0)
                    $(this).next().val(null);
                else
                    $(this).next().val(JSON.stringify({ SchemaID: SchemaID, ViewID: ViewID }));
            });
            $(".schemapropertydetails", Container).each(function () {
                var SchemaID = <string>$("input.schemapicker", this).val();
                var PropertyID = <string>$("input.simplepropertypicker", this).val();
                if (PropertyID.length == 0 || PropertyID == "0")
                    $(this).next().val(null);
                else
                    $(this).next().val(JSON.stringify({ SchemaID: SchemaID, PropertyID: PropertyID }));
            });
            $(".schemaviewpropertydetails", Container).each(function () {
                var SchemaID = <string>$("input.schemapicker", this).val();
                var ViewID = <string>$("input.viewpicker", this).val();
                var ViewPropertyID = <string>$("input.viewpropertypicker", this).val();
                if (SchemaID.length == 0 || ViewPropertyID.length == 0 || ViewPropertyID == "0")
                    $(this).next().val(null);
                else
                    $(this).next().val(JSON.stringify({ SchemaID: SchemaID, ViewID: ViewID, ViewPropertyID: ViewPropertyID }));
            });
            OfficeGuy.Inputs.Canvas.Serialize(Container);
        }

        static PreventMissingCompanyID(): boolean {
            var $Button_Save;
            OfficeGuy.Modals.Create({
                Title: OfficeGuy.Resources.GetString("CRM", "CompanyDetails"),
                Body: OfficeGuy.Resources.GetString("CRM", "CompanyDetails_HeaderNonAccounting"),
                Buttons: [
                    $Button_Save = $(document.createElement('button'))
                        .attr("type", "button")
                        .addClass("og-button-ui-action og-button-color-submit")
                        .html(OfficeGuy.Resources.GetString("CRM", "CompanyDetails_Fill"))
                        .on("click", function () {
                            Navigation.Redirect("/companies/details/");
                        })
                ],
                Simple: true,
                EnterEvent: function () {
                    $Button_Save.trigger("click");
                    return false;
                }
            });
            return false;
        }

        static SingleEntity_Command(EntityID, SchemaID, Name, ConfirmTitle?, ConfirmMessage?, ConfirmButton?): boolean {
            if (ConfirmMessage === undefined || ConfirmMessage == null) {
                Common.AjaxRequest({
                    URL: "/crm/entitycommand/",
                    Data: {
                        ID: EntityID,
                        SchemaID: SchemaID,
                        Command: Name
                    }
                });
            }
            else {
                OfficeGuy.Modals.ShowConfirmDialog({
                    Title: ConfirmTitle,
                    Message: ConfirmMessage,
                    ConfirmText: ConfirmButton,
                    ConfirmEvent: function () {
                        Main.SingleEntity_Command(EntityID, SchemaID, Name);
                    }
                });
            }
            return false;
        }

        static DownloadEntity(ID, SchemaID): boolean {
            OfficeGuy.Navigation.DownloadAsyncAddCookieIdentifier("/crm/downloadentity/?id=" + ID + "&schemaid=" + SchemaID);
            return false;
        }

        static DownloadView(SchemaID, ViewID): boolean {
            OfficeGuy.Navigation.DownloadAsyncAddCookieIdentifier("/crm/downloadview/?schemaid=" + SchemaID + "&viewid=" + ViewID);
            return false;
        }

        static UpdatePropertyNotification(EntityID, PropertyID, Value, RefreshPage = false): boolean {
            OfficeGuy.Notifications.Clear();
            Common.AjaxRequest({
                URL: "/crm/updatepropertynotification/",
                Data: {
                    EntityID: EntityID,
                    Values: [{
                        PropertyID: PropertyID,
                        Value: Value
                    }]
                },
                SuccessMethod: function () {
                    if (RefreshPage)
                        Navigation.Redirect(window.location.href);
                },
                ShowLoading: false
            });
            return false;
        }

        static ShowHideView(SchemaID: number, ViewID: number, $Link) {
            var $Icon = $Link.find("span");
            var Hidden = $Icon.hasClass("icon-heart");
            $Icon.toggleClass("icon-heart", !Hidden).toggleClass("icon-heart-empty", Hidden);

            Common.AjaxRequest({
                URL: "/views/showhide/",
                Data: {
                    SchemaID: SchemaID,
                    ViewID: ViewID,
                    Hidden: Hidden
                }
            });
            return false;
        }

        static ShowConfirmationPreSaveEntity(Title: string, Message: string, ButtonText: string, ButtonEvent?: any) {
            var $Modal = OfficeGuy.Modals.ShowConfirmDialog({
                Title: Title,
                Message: Message,
                ConfirmText: "חזרה לעריכה",
                ConfirmEvent: function () {
                    Modals.Hide($Modal);
                },

                CancelAllowed: true,
                CancelClass: "og-button-color-default",
                CancelText: ButtonText,
                CancelEvent: function () {
                    if (ButtonEvent)
                        ButtonEvent();
                    var $Input = $('input[name=BypassConstraintWarnings]');
                    if ($Input.length > 1) {
                        $Input = $Input.filter(function () {
                            return $(this).closest('.modal').length > 0;
                        });
                    }

                    $Input.val('true').closest('form');
                    Forms.SubmitForm($Input.closest('form'));
                },
            });
        }
    }
}

$(document).on("Teva.Init", function () {
    OfficeGuy.CRM.Main.Init();
});

$(document).on("Teva.PageLoad", function () {
    OfficeGuy.CRM.Main.PageLoad();
});
